import { GridContent } from "@ant-design/pro-layout";
import React, { Component } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Modal, Card, Col, Row, DatePicker } from 'antd'
import styles from './couponStatsDialog.module.scss';
import CouponLine from './charts/couponLine'
import CouponPie from './charts/couponPie'
import * as apis from '@/apis';
import moment from 'moment';
const { RangePicker } = DatePicker;
class CouponStatsComponent extends Component {
  state = {
    loading: false,
    countData: [],
    amountData: [],
    dailyCountData: [],
    dailyAmountData: [],
    days: []
  }
  componentDidMount() {
    const start = moment().subtract(30, 'days')
    const end = moment();
    this.setDays(start, end)
    this.getCouponsStats(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'))
  }

  getCouponsStats = async (startDate, endDate) => {
    const { type, id } = this.props
    let countData = null
    let amountData = null
    let dailyCountData = null
    let dailyAmountData = null
    if (type == 'worker') {
      countData = await apis.getWorkerCouponCount({ worker: id, startDate: startDate, endDate: endDate })
      amountData = await apis.getWorkerCouponAmount({ worker: id, startDate: startDate, endDate: endDate })
      dailyCountData = await apis.getWorkerCouponDailyCount({ worker: id, startDate: startDate, endDate: endDate })
      dailyAmountData = await apis.getWorkerCouponDailyAmount({ worker: id, startDate: startDate, endDate: endDate })
    } else if (type == 'bonus') {
      countData = await apis.getWorkerCouponCount({ startDate: startDate, endDate: endDate })
      amountData = await apis.getWorkerCouponAmount({ startDate: startDate, endDate: endDate })
      dailyCountData = await apis.getWorkerCouponDailyCount({ startDate: startDate, endDate: endDate })
      dailyAmountData = await apis.getWorkerCouponDailyAmount({ startDate: startDate, endDate: endDate })
    } else if (type == 'cash') {
      countData = await apis.getTenantCouponCount({ startDate: startDate, endDate: endDate })
      amountData = await apis.getTenantCouponAmount({ startDate: startDate, endDate: endDate })
      dailyCountData = await apis.getTenantCouponDailyCount({ startDate: startDate, endDate: endDate })
      dailyAmountData = await apis.getTenantCouponDailyAmount({ startDate: startDate, endDate: endDate })
    } else if (type == 'tenant') {
      countData = await apis.getTenantCouponCount({ tenant: id, startDate: startDate, endDate: endDate })
      amountData = await apis.getTenantCouponAmount({ tenant: id, startDate: startDate, endDate: endDate })
      dailyCountData = await apis.getTenantCouponDailyCount({ tenant: id, startDate: startDate, endDate: endDate })
      dailyAmountData = await apis.getTenantCouponDailyAmount({ tenant: id, startDate: startDate, endDate: endDate })
    }
    this.setState({
      countData: countData,
      amountData: amountData,
      dailyCountData: dailyCountData,
      dailyAmountData: dailyAmountData
    })
  }

  setDays(start, end) {
    let days = []
    let s1 = moment(start) //拷贝一个 不然会影响
    while (s1 <= end) {
      days.push(s1.format('YYYY-MM-DD'));
      s1 = s1.add(1, 'days')
    }
    this.setState({ days: days })
  }

  render() {
    const { type, id } = this.props
    let couponName = '';
    if (type == 'worker') {
      couponName = '奖金券'
    } else if (type == 'bonus') {
      couponName = '奖金券'
    } else if (type == 'cash') {
      couponName = '代金券'
    } else if (type == 'tenant') {
      couponName = '代金券'
    }

    const onChange = (dates) => {
      this.setDays(dates[0], dates[1])
      this.getCouponsStats(dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD'))
    }

    return (
      <>
        <div style={{ textAlign: "left", marginBottom: 10 }}>时间范围：<RangePicker onChange={onChange} defaultValue={[moment().subtract(30, 'days'), moment()]}
          format="YYYY-MM-DD"
          placeholder="选择起止时间"
        /></div>
        <GridContent>
          <React.Fragment>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Card title={`${couponName}数量统计（张00）`} bordered={false}>
                      <div className={styles.mapChart}>
                        <CouponPie name={`${couponName}数量统计（张）`} type="count" data={this.state.countData} />
                      </div>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card title={`${couponName}金额统计（元）`} bordered={false}>
                      <div className={styles.mapChart}>
                        <CouponPie name={`${couponName}金额统计（元）`} type="amount" data={this.state.amountData} />
                      </div>
                    </Card>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Card
                      title={`${couponName}每天数量统计（张）`}
                      bordered={false}
                      className={styles.pieCard}
                    >
                      <CouponLine data={this.state.dailyCountData} days={this.state.days} />
                    </Card>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Card
                      title={`${couponName}每天金额统计（元）`}
                      bordered={false}
                      className={styles.pieCard}
                    >
                      <CouponLine data={this.state.dailyAmountData} days={this.state.days} />
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </React.Fragment>
        </GridContent>
      </>
    )

  }
}

const CouponStatsDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={1000}
    style={{ top: 30 }}
    visible={isOpen}
    onCancel={hide}>
    <CouponStatsComponent onSuccess={hide} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'COUPON_STATS_DIALOG',
})(CouponStatsDialog)
